import Services from '../../services'
import Cookies from 'cookies-js';
import {splitIdsCollection} from "../../utils/store";

const clientId = 'Z3JlZWRpc2dvb2QK';
const clientSecret = 'VerySecretKey1';

const state = {
  user: {
    name: null,
    surname: null,
    balance: 0,
    myAssets: [],
    notificationCount: 0,
    firstUse: false,
  },
  token: null,
  refreshToken: null,
  expiresIn: null,
  refreshTimer: null,
};

// getters
const getters = {
  isAuth: (state, getters, root) => {
    return state.token !== null;
  },
  check: (state, getters) => {
    return true;
  },
  token: (state, getters) => {
    return state.token;
  },
  fullname: (state) => {
    return `${state.user.name} ${state.user.surname}`;
  },
  myAssets: (state, getters, rState, rGetters) => {
    // return rGetters['assets/getByIds'](state.user.myAssetsIds);
    return state.user.myAssets;
  },
  balance: (state) => {
    return state.user.balance;
  },
  isFirstUse: s => s.user.firstUse,
};

// actions
const actions = {
  async login({commit, state, dispatch}, {login, password, remember}) {
    dispatch('wait/start', 'auth.login', { root: true });

    try {
      const data = await Services.Auth.login({login, password, clientId, clientSecret});

      commit('setToken', data.accessToken);
      commit('setRefreshToken', data.refreshToken);
      commit('setExpiresToken', data.accessToken.expires_in);

      if(remember) {
        Cookies.set('accessToken', data.accessToken);
        Cookies.set('refreshToken', data.refreshToken);
        Cookies.set('expiresToken', data.accessToken.expires_in);
      }
    } catch (e) {

    }

    dispatch('wait/end', 'auth.login', { root: true });
  },
  async logout({commit}) {
    commit('setToken', null);
    commit('setRefreshToken', null);
    commit('setExpiresToken', null);

    Cookies.expire('accessToken');
    Cookies.expire('refreshToken');
    Cookies.expire('expiresToken');
  },

  async updateAuthSession({commit, dispatch, state}) {
    const data = await Services.Auth.refreshToken({refreshToken: state.refreshToken, clientId, clientSecret});

    commit('setToken', data.accessToken);
    commit('setRefreshToken', data.refreshToken);
    commit('setExpiresToken', data.expires_in);

    Cookies.set('accessToken', data.accessToken);
    Cookies.set('refreshToken', data.refreshToken);
    Cookies.set('expiresToken', data.expires_in);
  },

  async updateRefreshTimer({commit, state, dispatch}) {
    const time = state.expiresIn - Date.now() / 1000;
    console.log(state.expiresIn * 1000);
    console.log(Date.now());
    console.log(state.expiresIn * 1000 - Date.now());
    console.log(time);
    console.log(time / 1000 + ' ms');
    console.log(time / 1000 / 60 + ' s');
    console.log(time / 1000 / 60 / 60 + ' min');

    const timerFn = async () => {
      await dispatch('updateAuthSession');
      dispatch('updateRefreshTimer');
    };

    // commit('setRefreshTimer', setTimeout(timerFn, time - 2000));
  },

  async updateUserData({commit, state, dispatch}) {
    dispatch('wait/start', 'auth.fetchUserData', { root: true });
    const data = await Services.Auth.fetchUserData(state.token);

    const { ids: assetsIds, objects: assetsObjects } = splitIdsCollection(data.myAssets);

    if(assetsObjects.length > 0) {
      await dispatch('assets/pushAssets', assetsObjects, {root: true});
    }

    if(assetsIds.length > 0) {
      await dispatch('assets/fetchAssets', assetsIds, {root: true});
    }

    delete data.myAssets;

    commit('updateUserData', {
      ...data,
      myAssets: assetsIds.concat(assetsObjects.map(a => a.id)),
    });

    dispatch('wait/end', 'auth.fetchUserData', { root: true });
  },

  async changeFirstUse({commit, state, dispatch}, value) {
    Services.Auth.changeUserData({firstUse: value});

    commit('updateUserData', {
      firstUse: value
    });
  }
};

// mutations
const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setRefreshToken(state, token) {
    state.refreshToken = token;
  },
  setExpiresToken(state, expiresIn) {
    state.expiresIn = parseInt(expiresIn);
  },
  setRefreshTimer(state, timer) {
    if(state.refreshTimer) {
      clearTimeout(state.refreshTimer);
    }

    state.refreshTimer = timer;
  },
  updateUserData(state, mergeData) {
    state.user = {
      ...state.user,
      ...mergeData,
    }
  },
  decrementNotificationCount(state) {
    state.user.notificationCount--;
  },
  followAssets(state, {id, status}) {
    if(status === true) {
      state.user.myAssets.push(id);
    } else {
      if(state.user.myAssets.indexOf(id) !== null) {
        state.user.myAssets.splice(state.user.myAssets.indexOf(id), 1);
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js